import React from 'react'
import '../../../styles/accountsNew.css'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import { useHistory } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { accountsSelector, getMenuListSelector } from '../../../selectors'
import { MENU_OPTIONS } from '../../../layout/Layout/menu-options'
import MenuCard from '../../../layout/Navigation/menu-card'

const menuDetails =  MENU_OPTIONS.filter(e => e.key === "ACCOUNTS")[0].children

export default function Accounts() {
  const history = useHistory()
  const accounts = useSelector(accountsSelector) || []
  const menuConfig = useSelector(getMenuListSelector)['ACCOUNTS'] || {}

  return (
    <LayoutWithAccountCard breadCumKey='ACCOUNTS'>
      <Row>
        {Object.keys(menuConfig).length>0 && menuDetails.map((option, index) => (
          <>
            {menuConfig[option.key] &&
              <MenuCard
                handleMenuCallback={() => (accounts.length > 0 ? history.push(option.link) : null)}
                icon={option.icon}
                name={option.title}
                description={option.desc}
                key={index}
              />
            }
          </>
        ))}
      </Row>

      {/* <div className='d-flex'>
        <div className='account-menu-card' onClick={() => history.push('/statement')}>
          <img src={StatementIcon} />
          <h2>Statement</h2>
          <span>Lorem ipsum is simply</span>
        </div>
        <div className='account-menu-card'>
          <img src={AccountPaymentIcon} />
          <h2>Payments</h2>
          <span>Lorem ipsum is simply</span>
        </div>
        <div className='account-menu-card'>
          <img src={QuickTransferIcon} />
          <h2>Quick Transfer</h2>
          <span>Lorem ipsum is simply</span>
        </div>
      </div> */}

      {/* <div className='d-flex'>
        <div className='account-menu-card'>
          <img src={RequestIcon} />
          <h2>Requests</h2>
          <span>Lorem ipsum is simply</span>
        </div>
        <div className='account-menu-card'>
          <img src={BeneficiaryIcon} />
          <h2>Beneficiary Transfer</h2>
          <span>Lorem ipsum is simply</span>
        </div>
        <div className='account-menu-card'>
          <img src={StatementIcon} />
          <h2>Send to Mobile</h2>
          <span>Lorem ipsum is simply</span>
        </div>
      </div> */}

      {/* <div className='d-flex'>
        <div className='account-menu-card'>
          <img src={StatementIcon} />
          <h2>Loans</h2>
          <span>Lorem ipsum is simply</span>
        </div>
        <div className='account-menu-card'>
          <img src={StatementIcon} />
          <h2>Link Account</h2>
          <span>Lorem ipsum is simply</span>
        </div>
        <div className='account-menu-card'>
          <img src={StatementIcon} />
          <h2>De Link Account</h2>
          <span>Lorem ipsum is simply</span>
        </div>
      </div> */}

      {/* <div className='d-flex'>
        <div className='account-menu-card'>
          <img src={StatementIcon} />
          <h2>School Payments</h2>
          <span>Lorem ipsum is simply</span>
        </div>
        <div className='account-menu-card'>
          <img src={StatementIcon} />
          <h2>Other Payments</h2>
          <span>Lorem ipsum is simply</span>
        </div>
      </div> */}
    </LayoutWithAccountCard>
  )
}
